import reducer from "./reducer";
export { default as TypesOfSkillsIndicators } from "./components/index";
export { default as typesOfSkillsIndicatorsReducerName } from "./constants";
export default reducer;
